export default {
  title: 'Kullanıcı Yönetimi',
  gobitoLinkText: 'KULLANICI YÖNETİMİ NASIL KULLANILIR?',
  ownerAccount: 'Hesap Sahibi',
  deleteConfirmationText: 'Bu işlem tamamlandığında kullanıcı silinecek ve satıcı paneline giriş yapamayacaktır. Yeniden giriş yapması için kullanıcıyı tekrar eklemeniz gerekecektir.',
  reActivateUserConfirmationText: 'Bu işlem tamamlandığında kullanıcı tekrar aktif edilecek ve satıcı paneline giriş yapabilcektir.',
  passiveUserConfirmationText: 'Bu işlem tamamlandığında kullanıcı pasife alınacak ve satıcı paneline giriş yapamayacaktır. Yeniden giriş yapması için kullanıcıyı tekrar aktif etmeniz gerekecektir.',
  inputs: {
    label: {
      roles: 'KULLANICININ ROLÜ',
      store: 'MAĞAZA BİLGİSİ',
      name: 'KULLANICI ADI VE SOYADI',
      phone: 'TELEFON NUMARASI',
      myPhone: 'Telefon Numaram',
      phoneNumber: 'TELEFON NUMARASI',
      email: 'E-POSTA ADRESİ',
      currentPassword: 'MEVCUT ŞİFRENİZ',
      newPassword: 'YENİ ŞİFRENİZ',
      passwordConfirmation: 'YENİ ŞİFRENİZ',
    },
    placeholder: {
      roles: 'Kullanıcı Rolü',
      store: 'Mağaza Bilgisi',
      searchQuery: 'Kullanıcı Adı ile arayınız',
      name: 'Ad ve Soyad',
      phone: 'Telefon Numarası',
      phoneNumber: '05__ ___ __ __',
      email: 'E-Posta Adresi',
      currentPassword: 'Mevcut şifre',
      newPassword: 'Yeni şifre',
      passwordConfirmation: 'Yeni şifre',
    },
    errors: {
      name: {
        required: 'Ad-Soyad bilgisi zorunlu bir alandır',
        turkishText: 'Girilen Ad-Soyad bilgisi geçersizdir',
        min: 'En az {value} karakter girilmelidir',
        max: 'En fazla {value} karakter girilmelidir',
        regex: 'Lütfen Ad Soyad giriniz',
      },
      email: {
        required: 'E-mail bilgisi zorunlu bir alandır',
        email: 'Girilen e-mail adresi geçersizdir',
      },
      role: {
        required: 'Role zorunlu bir alandır',
      },
      phoneNumber: 'Telefon bilgisi zorunlu bir alandır',
    },
    info: {
      email: 'Kullanıcının e-posta adresi güncellenemez.',
      roles: 'Kullanıcılara vereceğiniz roller satıcı panelinde ilgili menüler altında işlem yapabilmesini sağlar.',
    },
  },
  roles: {
    Master: 'Her carinin yalnızca bir tane <b>"Hesap Sahibi"</b> vardır. Hesap sahibi satıcı paneline tam erişime sahiptir. Hiçbir kullanıcı tarafından silinemez ve yetkileri değiştirilemez.',
    Yönetici: 'Bu role sahip kullanıcılar paneldeki <b>tüm menülere</b> erişebilir.',
    Other: 'Bu role sahip kullanıcılar panelde sadece <b>"{privileges}"</b> menülerine erişebilir.',
  },
  tooltip: {
    store: '{storeName} için yetkili',
  },
  header: {
    userList: 'Kullanıcı Listesi',
    searchButton: 'ARA',
    addNewUserButton: 'YENİ KULLANICI EKLE',
  },
  body: {
    restoreUserAction: 'Yeniden Ekle',
    deleteUserAction: 'Sil',
    changePasswordAction: 'Şifre Güncelle',
    reActivateUserAction: 'Aktif Et',
    passiveUserAction: 'Pasife Al',
    editUserAction: 'Düzenle',
    tableColumns: {
      name: 'KULLANICI ADI',
      email: 'E-POSTA',
      createdDate: 'OLUŞTURULMA TARİHİ',
      lastModifiedDate: 'GÜNCELLENME TARİHİ',
      role: 'KULLANICI ROLÜ',
      status: 'DURUMU',
      actions: 'İŞLEMLER',
      active: 'Aktif',
      passive: 'Pasif',
      deleted: 'Silindi',
    },
  },
  modal: {
    editUser: 'Kullanıcı Düzenle',
    changePassword: 'Şifre Güncelle',
    changePhoneNumber: 'Telefon Numarası Güncelle',
    addUser: 'Yeni Kullanıcı Ekle',
    addUserButton: 'YENİ KULLANICI EKLE',
    editUserButton: 'DEĞİŞİKLİKLERİ KAYDET',
    changePasswordButton: 'ŞİFREMİ DEĞİŞTİR',
    changePhoneNumberButton: 'NUMARAMI GÜNCELLE VE DOĞRULA',
  },
  passwordRules: {
    title: 'Güvenli Bir Şifre Oluşturun:',
    minPassword: 'Şifreniz en az 8 karakterden oluşmalıdır.',
    noNumber: 'Şifreniz en az bir rakam içermelidir.',
    noUpperAndLowerCase: 'Şifreniz en az bir büyük ve bir küçük harf içermelidir.',
    noSpecialCharacter: 'Şifreniz en az bir özel karakter içermelidir.',
  },
};
